//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import { domain } from 'teld-web-component/lib/env'
    export default {
        name: "t-footer",
        data() {
            return {
                domain:domain
            }
        },
        mounted(){
        }
    }



// WEBPACK FOOTER //
// ./src/components/tFooter.vue